import { render, staticRenderFns } from "./BatchModal.vue?vue&type=template&id=526e9124&scoped=true"
import script from "./BatchModal.vue?vue&type=script&lang=js"
export * from "./BatchModal.vue?vue&type=script&lang=js"
import style0 from "./BatchModal.vue?vue&type=style&index=0&id=526e9124&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526e9124",
  null
  
)

export default component.exports